import OrganizationInvitePage from "./organizationInvite";

export default OrganizationInvitePage;